// Production configuration
// This file contains production-specific configuration values
// Use this as a fallback when environment variables are not available

export const productionConfig = {
  // API Configuration
  API_BASE_URL: 'https://app.insight360apps.com/easycheck/api',
  
  // Stripe Configuration
 // STRIPE_PUBLISHABLE_KEY: 'pk_test_51RgOasH1SbnorHOyZ1bs2eTby4Ls971OLUMH',
  //STRIPE_WEBHOOK_SECRET: 'whsec_QbXDcODxmULnGJAwgohS1A6nhKP9kbBh',
  
  STRIPE_PUBLISHABLE_KEY: 'pk_live_51K3FW4HJay5VsWAhMYgQVEHQDtB7S9JPJ4tQfVJgqwMMenzrRdRG2ogVjCC6llWp4iButUxMszGP87g2G1bnLNJC009k25xDJM',
  STRIPE_WEBHOOK_SECRET: 'whsec_QbXDcODxmULnGJAwgohS1A6nhKP9kbBh',


  // App Configuration
  APP_NAME: 'EasyCheck',
  
  // Environment detection
  IS_PRODUCTION: window.location.origin.includes('easycheckpro.com'),
  
  // Get configuration value with fallback
  get: (key) => {
    // First try environment variables
    const envValue = process.env[`REACT_APP_${key}`];
    if (envValue && envValue !== 'undefined') {
      return envValue;
    }
    
    // Fallback to production config
    switch (key) {
      case 'API_BASE_URL':
        return productionConfig.API_BASE_URL;
      case 'STRIPE_PUBLISHABLE_KEY':
        return productionConfig.STRIPE_PUBLISHABLE_KEY;
      case 'STRIPE_WEBHOOK_SECRET':
        return productionConfig.STRIPE_WEBHOOK_SECRET;
      case 'APP_NAME':
        return productionConfig.APP_NAME;
      default:
        return null;
    }
  }
}; 